import React, { forwardRef } from "react";
import { bool, func, object, oneOf, string } from "prop-types";

import componentSizes from "../../constants/componentSizes";
import Field from "../Field";
import PasswordInput from "./components/PasswordInput";

const PasswordField = forwardRef(
  (
    {
      className,
      defaultValue,
      disabled,
      error,
      helper,
      id,
      inputOptions,
      isValid,
      label,
      onChange,
      required,
      size,
      value,
      ...passThroughProps
    },
    ref
  ) => (
    <Field
      ref={ref}
      className={className}
      error={error}
      helper={helper}
      id={id}
      isValid={isValid}
      label={label}
      {...passThroughProps}
    >
      <PasswordInput
        defaultValue={defaultValue}
        disabled={disabled}
        isValid={isValid}
        onChange={onChange}
        required={required}
        size={size}
        value={value}
        {...inputOptions}
      />
    </Field>
  )
);

PasswordField.displayName = "PasswordField";

PasswordField.propTypes = {
  className: string,
  // eslint-disable-next-line react/require-default-props
  defaultValue: string,
  disabled: bool,
  error: string,
  helper: string,
  hint: string.isRequired,
  id: string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  inputOptions: object,
  isValid: bool,
  label: string.isRequired,
  onChange: func,
  required: bool,
  size: oneOf([componentSizes.SM, componentSizes.MD, componentSizes.LG]),
  // eslint-disable-next-line react/require-default-props
  value: string
};

PasswordField.defaultProps = {
  className: "",
  disabled: false,
  error: "",
  isValid: true,
  helper: "",
  inputOptions: {},
  onChange: () => {},
  required: false,
  size: componentSizes.MD
};

export default PasswordField;
